import { requestBuilder } from '../../http/RequestBuilder';
import type { GeneralResponse } from '../../http/types/Common';

interface BillsApiClearParams {
    membershipId: string;
}

export const useClearAllBills = requestBuilder.mutation<
    GeneralResponse,
    null,
    BillsApiClearParams
>({
    endpoint: ({ membershipId }) =>
        `/api/holistic-bills/${membershipId}/bills/`,
    method: 'DELETE',
});
